import base from "./base.service";

const instance = base.service();

export const getAll = () => {
    return instance.get("/kategorijaDokumenta/all"); 
};

export const getById = (id) =>
{
    return instance.get(`/kategorijaDokumenta/${id}`);
}

export default {
    getAll, getById
};